module.exports = __webpack_public_path__ + "img/qq.bfbe0630.png";